import React from "react";
import {
  UIActivityIndicator,
  UIActivityIndicatorProps,
} from "react-native-indicators";

import { colors } from "assets/constants";
import { useRecoilValue } from "recoil";
import { authAtom } from "stores";

const Loading: React.FC<LoadingT & UIActivityIndicatorProps> = ({
  size,
  color,
  ...props
}) => {
  const { company } = useRecoilValue(authAtom);

  return (
    <UIActivityIndicator
      color={color || company?.color}
      size={size || 35}
      {...props}
    />
  );
};

export default Loading;
